import Category from "../components/Category";
import BreadcrumbShop from "../components/BreadcrumbShop";

const Phones = () => {
  return (
    <div>
      <BreadcrumbShop curPage={"Phones"} />
      <Category talk={"Phones"} />
    </div>
  );
};

export default Phones;
